/**
 * Line discount typed as an AMOUNT (2026-10-09).
 *
 * The screens keep the line discount as a % (prints, later documents and the
 * totals all work it out from the %). Cutting that % to 4 decimals could lose
 * a paisa: 70 off 27,785 → 0.2519% → 69.99. So keep the SHORTEST % (4 decimals
 * or more) that gives back exactly the typed amount, to the paisa, with the
 * same sum the screens use (amount × % ÷ 100, rounded to 2 decimals).
 */
export const percentForDiscountAmount = (gross, amount) => {
  const g = Number(gross) || 0;
  const a = Math.max(0, Number(amount) || 0);
  if (g <= 0 || a <= 0) return 0;
  if (a >= g) return 100;
  const exact = (a / g) * 100;
  const target = Math.round(a * 100) / 100;
  for (let d = 4; d <= 12; d += 1) {
    const f = 10 ** d;
    const p = Math.round(exact * f) / f;
    if (Math.round(g * (p / 100) * 100) / 100 === target) return p;
  }
  return exact;
};

export default percentForDiscountAmount;
